import type { User } from "oidc-client-ts";

export const VIEWER_ROLE = "next.viewer";

const ORG_ID_CLAIM = "urn:zitadel:iam:user:resourceowner:id";

type ZitadelRoleClaim = Record<string, Record<string, string>>;

type ProfileLike = Record<string, unknown> | undefined | null;

export function extractOrgId(
  profile: ProfileLike,
  projectId?: string
): string | null {
  if (!profile) return null;

  const direct = profile[ORG_ID_CLAIM];
  if (typeof direct === "string" && direct.length > 0) return direct;

  if (projectId) {
    const roles = extractRoles(profile, projectId);
    for (const grant of Object.values(roles)) {
      if (grant && typeof grant === "object") {
        const orgIds = Object.keys(grant);
        const first = orgIds[0];
        if (first) return first;
      }
    }
  }

  return null;
}

function rolesClaimKey(projectId: string): string {
  return `urn:zitadel:iam:org:project:${projectId}:roles`;
}

export function extractRoles(
  profile: ProfileLike,
  projectId: string
): ZitadelRoleClaim {
  if (!profile) return {};
  const value = profile[rolesClaimKey(projectId)];
  if (value && typeof value === "object") {
    return value as ZitadelRoleClaim;
  }
  return {};
}

export function hasViewerRole(
  profile: ProfileLike,
  projectId: string
): boolean {
  const roles = extractRoles(profile, projectId);
  return VIEWER_ROLE in roles;
}

export function isAuthorized(
  user: User | null | undefined,
  expectedOrgId: string,
  projectId: string
): boolean {
  if (!user) return false;
  const profile = user.profile as ProfileLike;
  return (
    extractOrgId(profile, projectId) === expectedOrgId &&
    hasViewerRole(profile, projectId)
  );
}
